import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for creating a Confluence whiteboard.
 */

/**
 * Properties for the Confluence whiteboard creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to create a new Confluence whiteboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence whiteboard with the specified content.
 */
export var ConfluenceWhiteboardCreateCommand = createCommand('confluence-whiteboard-create-command');